<!-- Modal mode (opened via SendDataService.openModalPopup) -->
<ng-container *ngIf="isModal; else standaloneMode">
  <div class="modal-container d-flex flex-column h-auto">
    <div class="modal-header border-0">
      <h1 class="text-primary-color">Template Settings</h1>
    </div>
    <div class="modal-body overflow-y-auto overflow-x-hidden">
      <div class="col-12 px-0">
        <ng-container *ngTemplateOutlet="templateForm"></ng-container>
      </div>
    </div>
    <div class="modal-footer border-0">
      <div class="d-flex m-0 gap-3">
        <app-button
          [button_2]="true"
          [buttonClass]="'button button-info mx-0'"
          [buttonLable]="enumButtonName.CANCEL"
          (click)="closeModal()">
        </app-button>
        <app-button
          [button_2]="true"
          [buttonClass]="(data?.templateData?.selectedOption && (data?.templateData?.selectedOption === '1' || data?.templateData?.templateName)) ? 'button button-primary mx-0' : 'button dark-info mx-0'"
          [buttonLable]="enumButtonName.SAVE"
          [buttonType]="'submit'"
          (click)="saveModal()">
        </app-button>
      </div>
    </div>
  </div>
</ng-container>

<!-- Standalone mode (used inside the stepper) -->
<ng-template #standaloneMode>
  <div class="container-fluid px-0" [ngClass]="{'loaderShow': data?.isLoading}">
    <div class="row justify-content-center">
      <div class="col-10 px-0">
        <div class="row">
          <div class="col-xl-6 col-md-12 box" [style]="{'height': flexHeight}">
            <ng-container *ngTemplateOutlet="templateForm"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-custom-loader class="position-absolute top-50 start-50 translate-middle" style="z-index: 6;" [isLoaderLoading]="data?.isLoading"></app-custom-loader>
</ng-template>

<!-- Shared form content -->
<ng-template #templateForm>
  <div class="mb-3">
    <label class="font-16 text-gray" for="">Import File Name</label>
    <div class="font-16 text-primary-color">{{data?.templateData?.fileName || 'Filename.xlsx'}}</div>
  </div>
  <div class="mb-4">
    <label class="font-16 text-gray" for="">Template Details<i class="fst-normal ps-1 p-0 text-danger">*</i></label>
    <div class="form-check">
      <div class="radio popup-label radio-p">
        <input class="form-check-input hand" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
          [(ngModel)]="data.templateData.selectedOption" value="1">
        <label class="form-check-label popup-secondary-text hand" for="flexRadioDefault1">
          Take no mapping template action.
        </label>
      </div>
      <div class="radio popup-label radio-p" [ngClass]="{'cursor-notAllowed': isMappingIdDisabled}">
        <input class="form-check-input" [ngClass]="isMappingIdDisabled ? '' : 'hand'"
          type="radio" name="flexRadioDefault" id="flexRadioDefault2"
          [(ngModel)]="data.templateData.selectedOption"
          [attr.disabled]="isMappingIdDisabled ? '' : null"
          [ngClass]="{'pe-none': isMappingIdDisabled}" value="2">
        <label class="form-check-label popup-secondary-text" [ngClass]="{'pe-none': isMappingIdDisabled, 'hand': !isMappingIdDisabled}" for="flexRadioDefault2">
          Update current mapping template.
        </label>
      </div>
      <div class="radio popup-label radio-p">
        <input class="form-check-input hand" type="radio" name="flexRadioDefault" id="flexRadioDefault3"
          [(ngModel)]="data.templateData.selectedOption" value="3">
        <label class="form-check-label popup-secondary-text hand" for="flexRadioDefault3">
          Save as new mapping template.
        </label>
      </div>
    </div>
  </div>
  <div class="mb-3">
    <label class="font-16 text-gray w-100" for="templateName">Template Name<i class="fst-normal ps-1 p-0 text-danger">*</i></label><br>
    <input class="form-control font-16 text-light-gray" autocomplete="off" type="text" id="templateName"
      name="templateName"
      [(ngModel)]="data.templateData.templateName"
      [ngClass]="{'border-red': !data.templateData.templateName && data?.templateData?.isValid && data?.templateData?.selectedOption !== '1'}"
      [required]="data?.templateData?.selectedOption !== '1'"
      [attr.disabled]="data?.templateData?.selectedOption === '1' ? '' : null" />
  </div>
  <div class="mb-3">
    <label class="font-16 text-gray w-100" for="description">Template Description</label><br>
    <textarea class="form-control font-16 text-light-gray" id="description" rows="4"
      name="description"
      [(ngModel)]="data.templateData.templateDescription"
      [attr.disabled]="data?.templateData?.selectedOption === '1' ? '' : null"></textarea>
  </div>
</ng-template>